import { render, staticRenderFns } from "./Rekommendationer.vue?vue&type=template&id=45024afb&"
import script from "./Rekommendationer.vue?vue&type=script&lang=js&"
export * from "./Rekommendationer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/wordpress/Kaypa-hoito/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45024afb')) {
      api.createRecord('45024afb', component.options)
    } else {
      api.reload('45024afb', component.options)
    }
    module.hot.accept("./Rekommendationer.vue?vue&type=template&id=45024afb&", function () {
      api.rerender('45024afb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/Rekommendationer.vue"
export default component.exports